import { render, staticRenderFns } from "./BalanceSheetComparison.vue?vue&type=template&id=2e3e67da"
import script from "./BalanceSheetComparison.vue?vue&type=script&lang=js"
export * from "./BalanceSheetComparison.vue?vue&type=script&lang=js"
import style0 from "./BalanceSheetComparison.vue?vue&type=style&index=0&id=2e3e67da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports